import { type GradeWithCategories } from "@core/grades/types";
import {
  GradeChapterNavigator,
  GradeChapterSection,
  GradeDetailsEmptyState,
  GradeDetailsHero,
} from "../components/GradeDetails";
import { useGradeDetailsPage } from "../hooks/use-grade-details-page.hook";

type GradeDetailsPageContentProps = {
  grade: GradeWithCategories;
};

export function GradeDetailsPageContent({
  grade,
}: GradeDetailsPageContentProps) {
  const page = useGradeDetailsPage(grade);

  return (
    <div className="relative isolate overflow-hidden">
      <div className="pointer-events-none absolute inset-x-0 top-0 -z-10 h-[520px] bg-gradient-to-b from-primary-50/70 via-white to-transparent dark:from-primary-950/20 dark:via-slate-950" />

      <div className="container mx-auto space-y-6 px-4 py-5 sm:space-y-8 sm:px-6 sm:py-8 lg:px-8 lg:py-10">
        <GradeDetailsHero
          breadcrumbs={page.breadcrumbs}
          grade={grade}
          theme={page.theme}
          totalCategories={page.totalCategories}
          totalLessons={page.totalLessons}
        />

        {page.hasCategories ? (
          <>
            <GradeChapterNavigator
              categories={page.categories}
              gradeName={grade.name}
              theme={page.theme}
            />
            <main className="space-y-7 sm:space-y-9">
              {page.categories.map(item => (
                <GradeChapterSection
                  key={item.category.id}
                  item={item}
                  theme={page.theme}
                />
              ))}
            </main>
          </>
        ) : (
          <GradeDetailsEmptyState theme={page.theme} />
        )}
      </div>
    </div>
  );
}
